// src/components/ReturnPolicy.jsx

import React from 'react';
import { Link } from 'react-router-dom';

const ReturnPolicy = () => {
  return (
    <div className="relative container mx-auto p-8 md:p-16" dir="rtl">

      {/* زر العودة إلى الرئيسية */}
      <div className="absolute top-8 left-8">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-bold
            bg-[#F2B705] text-[#1B1B1F] hover:bg-[#1B1B1F] hover:text-white
            transition-colors duration-200 shadow-sm
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
        >
          العودة إلى الرئيسية
          <svg className="h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </Link>
      </div>

      {/* قسم العنوان والمقدمة */}
      <div className="text-center mb-16 pt-16 md:pt-0">
        <span
          className="inline-block px-4 py-1 rounded-full bg-[#F2B705]/15 text-[#1B1B1F] text-sm font-bold -rotate-2 mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          #الإرجاع_والاستبدال
        </span>
        <h1
          className="text-4xl md:text-6xl font-extrabold text-[#1B1B1F] mb-4"
          style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
        >
          سياسة الإرجاع والاستبدال
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          نسعى لضمان رضاكم التام. إليكم التفاصيل الخاصة بسياسات الإرجاع والاستبدال للمنتجات التي يتم شراؤها من متجرنا.
        </p>
      </div>

      {/* أقسام السياسة */}
      <div className="bg-white p-8 rounded-2xl shadow-[0_2px_10px_rgba(27,27,31,0.08)]">
        <div className="space-y-10">

          {/* فترة الإرجاع */}
          <div className="pr-4 border-r-4 border-[#F2B705]">
            <h2
              className="text-2xl font-bold text-[#1B1B1F] mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              فترة الإرجاع
            </h2>
            <p className="text-gray-700 leading-relaxed text-right">
              يمكنك إرجاع معظم المنتجات خلال فترة <strong className="font-bold text-[#1B1B1F]">14 يومًا</strong> من تاريخ استلام الطلب. يجب أن يكون المنتج في حالته الأصلية وغير مستخدم، مع وجود جميع الملحقات والتغليف الأصلي.
            </p>
          </div>

          {/* شروط الإرجاع */}
          <div className="pr-4 border-r-4 border-[#1B1B1F]">
            <h2
              className="text-2xl font-bold text-[#1B1B1F] mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              شروط الإرجاع
            </h2>
            <ul className="list-disc text-gray-700 leading-relaxed space-y-3 pr-6">
              <li>يجب أن يكون المنتج في حالته الأصلية وغير مستخدم.</li>
              <li>يجب إرفاق الفاتورة الأصلية أو إثبات الشراء.</li>
              <li>يتم إرجاع المنتجات القابلة للإرجاع فقط (منتجات النظافة الشخصية لا يمكن إرجاعها).</li>
            </ul>
          </div>

          {/* كيفية تقديم طلب إرجاع */}
          <div className="pr-4 border-r-4 border-[#F2B705]">
            <h2
              className="text-2xl font-bold text-[#1B1B1F] mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              كيفية تقديم طلب إرجاع
            </h2>
            <ol className="list-decimal text-gray-700 leading-relaxed pr-6 space-y-2">
              <li>تواصل مع فريق خدمة العملاء عبر صفحة "اتصل بنا".</li>
              <li>قدم رقم الطلب وتفاصيل المنتج الذي ترغب في إرجاعه.</li>
              <li>سيقوم فريقنا بمراجعة الطلب وتزويدك بتعليمات الإرجاع.</li>
            </ol>
          </div>

          {/* استرداد الأموال */}
          <div className="pr-4 border-r-4 border-[#1B1B1F]">
            <h2
              className="text-2xl font-bold text-[#1B1B1F] mb-3"
              style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
            >
              استرداد الأموال
            </h2>
            <p className="text-gray-700 leading-relaxed text-right">
              سيتم استرداد قيمة المنتج بعد استلامه وفحصه، وقد يستغرق الأمر من <strong className="font-bold text-[#1B1B1F]">7 إلى 14 يوم عمل</strong> لإتمام عملية الاسترداد. تختلف طريقة الاسترداد حسب طريقة الدفع الأصلية.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;
